import { render, staticRenderFns } from "./IconDeleteLinear.vue?vue&type=template&id=281a1091&scoped=true"
import script from "./IconDeleteLinear.vue?vue&type=script&lang=js"
export * from "./IconDeleteLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281a1091",
  null
  
)

export default component.exports